import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import API from '../../../create/api';
import querystring from 'querystring';
import _ from 'lodash';
import * as helper from '../../../../helper/index';
import TextField from '@mui/material/TextField';
import Grid from '@material-ui/core/Grid';
import Rider from '../../../fields/rider';
import { toastr } from 'react-redux-toastr';
import BookParcel from '../parcel/create';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import moment from 'moment';
import { useStore } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import FormControl from '@mui/material/FormControl';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import { InputLabel, Input, Box, Chip } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import ParcelStatusLineChart from './parcelStatusLineChart';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  tdBorder: { border: '1px black solid', fontSize: '20px', padding: '0 5px' },
  onlyPrint: { display: 'none' },
  hidePrint: {},
  printStyle: {},
  numberSize: { fontSize: '1rem' },
  receiveColumn: {},
  '@media print': {
    'table tr': {
      pageBreakBefore: 'always',
    },
    hidePrint: {
      display: 'none',
    },
    onlyPrint: { display: 'block' },
    printStyle: {
      border: '1px black solid',
      fontSize: '20px',
      padding: '0 5px',
    },
    numberSize: { fontSize: '1rem' },
    receiveColumn: {
      width: '100%',
    },
  },
}));

export default function RidersBook() {
  const classes = useStyles();
  const store = useStore();
  const [loading, setLoading] = useState(false);
  const [print, setPrint]: any = useState(false);
  const [get_rows, setRows]: [any[], any] = useState([]);
  const [get_rider, set_rider]: any = useState(null);
  const [get_payment_start_date, set_payment_start_date] = useState(moment().format('YYYY-MM-DD'));
  const [get_payment_end_date, set_payment_end_date] = useState('');
  const [get_status, set_status] = React.useState<string[]>(['ON_DELIVERY']);

  async function fetchAPI() {
    setLoading(true);
    const param: {
      _limit?: number;
      status_in?: string[];
      rider?: string;
      _sort?: string;
      payment_date?: string;
      payment_date_gte?: string;
      payment_date_lte?: string;
    } = {
      _limit: 1000,
      status_in: get_status?.length ? get_status : undefined,
      rider: get_rider?.value ?? undefined,
      _sort: 'id:DESC',
    };

    const isStartValid = moment(get_payment_start_date, 'YYYY-MM-DD', true).isValid();
    const isEndValid = moment(get_payment_end_date, 'YYYY-MM-DD', true).isValid();

    // If only start date is given, treat it as an exact-day filter.
    if (isStartValid && !isEndValid) {
      param.payment_date = moment(get_payment_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD');
    } else {
      if (isStartValid) {
        param.payment_date_gte = moment(get_payment_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD');
      }
      if (isEndValid) {
        param.payment_date_lte = moment(get_payment_end_date, 'YYYY-MM-DD').format('YYYY-MM-DD');
      }
    }

    const qs = querystring.encode(_.pickBy(param, _.identity));

    const url = `${process.env.REACT_APP_API_SERVER}/parcels?${qs}`;

    API.getAll(url)
      .then((parcels: any) => {
        setRows(parcels);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  useEffect(() => {
    fetchAPI();
    // eslint-disable-next-line
  }, [get_rider, get_status, get_payment_start_date, get_payment_end_date]);

  const [get_search, set_search]: [number | null, any] = useState(null);
  const [get_searched_parcel, set_searched_parcel]: any = useState({});

  useEffect(() => {
    if (get_search && get_search > 0) {
      setLoading(true);
      const url = `${process.env.REACT_APP_API_SERVER}/parcels`;
      API.get(url, Number(get_search))
        .then((parcel) => {
          set_searched_parcel(parcel);
        })
        .catch((err) => {
          console.error(err);
          set_searched_parcel({});
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line
  }, [get_search]);

  async function assign() {
    if (!get_rider?.value) {
      toastr.warning('Status', 'status should be ON_DELIVERY because Rider assigned');
      return;
    }
    const data = {
      status: 'ON_DELIVERY',
      rider: get_rider.value,
    };
    const url = `${process.env.REACT_APP_API_SERVER}/parcels`;
    API.update(url, Number(get_search), data)
      .then((parcel) => {
        fetchAPI();
        toastr.success('Updated', '');
      })
      .catch((e) => {
        helper.axiosErrorHandling(e);
      });
  }

  function MobileNo(mobile_no: string = '') {
    if (mobile_no && mobile_no.includes(',')) {
      return mobile_no.split(',').map((num, i) => {
        num = num.trim();
        if (num.length === 11) {
          return (
            <span>
              {num}
              <br />
            </span>
          );
        } else {
          return (
            <span>
              ,<span style={{ color: 'red', textDecoration: 'line-through' }}>{num}</span>
            </span>
          );
        }
      });
    } else {
      return mobile_no && mobile_no.trim().length === 11 ? (
        mobile_no
      ) : (
        <span style={{ color: 'red', textDecoration: 'line-through' }}>{mobile_no}</span>
      );
    }
  }

  function Rows(props: any = {}) {
    const classes = useStyles();
    // const store = useStore();
    const { row, serial } = props;

    const [open, setOpen]: any = useState(false);

    return (
      <React.Fragment>
        <TableRow key={row.id}>
          <TableCell className={classes.printStyle}>{serial}</TableCell>
          <TableCell className={classes.printStyle} align="center">
            {row.id}
            <hr style={{ margin: 0 }} />
            {row.memoNo}
          </TableCell>
          {!print && (
            <TableCell className={clsx(classes.printStyle, classes.hidePrint)} align="left">
              {row?.rider?.name}
            </TableCell>
          )}
          {!print && (
            <TableCell
              className={clsx(classes.printStyle, classes.hidePrint)}
              style={{ maxWidth: '100px', overflow: 'hidden' }}
              align="left"
              size="small"
            >
              {row.status}
            </TableCell>
          )}
          <TableCell className={classes.printStyle} align="left">
            {row?.company?.name}
          </TableCell>
          <TableCell className={clsx(classes.printStyle)} align="left">
            {row.customerName} <br />
            <span className={classes.numberSize}> {MobileNo(row.phoneNumber)}</span>
          </TableCell>
          <TableCell className={classes.printStyle} align="left">
            {row.address}
          </TableCell>

          <TableCell className={classes.printStyle} align="right">
            {row?.merchant_COD}
          </TableCell>
          <TableCell className={classes.printStyle} align="left">
            {row?.COD}
          </TableCell>

          {!print && (
            <TableCell className={clsx(classes.printStyle, classes.hidePrint)} align="left">
              <IconButton
                className={classes.hidePrint}
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
          )}
        </TableRow>
        {!print && (
          <TableRow className={classes.hidePrint}>
            <TableCell className={classes.printStyle} colSpan={12}>
              {open && <BookParcel parcel_id={row.id} />}
            </TableCell>
          </TableRow>
        )}
      </React.Fragment>
    );
  }

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    set_status(typeof value === 'string' ? value.split(',') : value);
  };

  // print
  const handlePrint = () => {
    store.dispatch({ type: 'CLOSE_SIDEBAR' });
    setTimeout(() => {
      window.print();
    }, 100);
  };

  return (
    <Grid container>
      <Grid item xs={12} md={12} className={classes.hidePrint}>
        <Paper className="bg-white p-3 md:p-4">
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} md={4}>
              <div className="w-full">
                <Rider
                  onChange={(rider: { label: string; value: string }) => {
                    set_rider(rider ?? null);
                  }}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="rider-dashboard-status-label">Status</InputLabel>
                <Select<string[]>
                  labelId="rider-dashboard-status-label"
                  id="rider-dashboard-status"
                  multiple
                  value={get_status}
                  onChange={handleChange}
                  input={<Input id="rider-dashboard-status-input" placeholder="Status" />}
                  renderValue={(selected) => (
                    <div className="flex flex-wrap gap-1">
                      {(selected as unknown as string[]).map((value) => (
                        <span key={value} className="text-sm">
                          {value}
                        </span>
                      ))}
                    </div>
                  )}
                >
                  {store.getState().parcel?.parcelStatus?.map((v: any, index: number) => (
                    <MenuItem key={`${v.label}-${index}-Select-item`} value={v.value}>
                      {v.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="Start date"
                type="date"
                fullWidth
                variant="standard"
                value={get_payment_start_date}
                onChange={(e) => {
                  const value = e.target.value;
                  set_payment_start_date(value ? moment(value).format('YYYY-MM-DD').toString() : '');
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="End date"
                type="date"
                fullWidth
                variant="standard"
                value={get_payment_end_date}
                onChange={(e) => {
                  const value = e.target.value;
                  set_payment_end_date(value ? moment(value).format('YYYY-MM-DD').toString() : '');
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={1}>
              <TextField
                disabled={!get_rider?.value}
                fullWidth
                label="APN"
                variant="standard"
                value={get_search}
                onChange={(e) => {
                  const search: any = e?.target?.value;
                  if (search) {
                    set_search(search);
                  } else {
                    set_searched_parcel({});
                    set_search(search);
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <div className="flex flex-wrap gap-2">
                <Button
                  disabled={
                    !get_searched_parcel?.id ||
                    !get_rider?.value ||
                    get_searched_parcel?.rider?.id === get_rider.value
                  }
                  color="primary"
                  onClick={assign}
                  variant="contained"
                  size="small"
                >
                  {get_searched_parcel?.rider?.id ? 'Change Rider' : 'Assign'}
                </Button>
                <Button color="primary" onClick={fetchAPI} variant="contained" size="small">
                  refresh
                </Button>
                <Button size="small" variant="contained" color="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12} md={12} className={classes.hidePrint}>
        <div className="my-3">
          <ParcelStatusLineChart
            riderId={get_rider?.value ?? null}
            start={get_payment_start_date}
            end={get_payment_end_date}
          />
        </div>
      </Grid>

      {get_searched_parcel?.id && (
        <Grid item xs={12} md={12} className={classes.hidePrint}>
          <Grid container component={Paper} className="my-4 p-2">
            <Grid item xs={3} md={1}>
              Company:
            </Grid>
            <Grid item xs={3} md={1}>
              {get_searched_parcel?.company?.name && <b>{get_searched_parcel?.company?.name}</b>}
            </Grid>
            <Grid item xs={6} md={1}>
              Invoice:
              {get_searched_parcel?.memoNo && <b>{get_searched_parcel?.memoNo}</b>}
            </Grid>
            <Grid item xs={3} md={1}>
              Customer:
            </Grid>
            <Grid item xs={3} md={1}>
              {get_searched_parcel?.customerName && <b>{get_searched_parcel?.customerName}</b>}
            </Grid>
            <Grid item xs={6} md={1}>
              COD: {get_searched_parcel?.COD && <b>{get_searched_parcel?.COD}</b>}
            </Grid>
            <Grid item xs={6} md={2}>
              Status:
              {get_searched_parcel?.status && <b>{get_searched_parcel?.status}</b>}
            </Grid>

            <Grid item xs={6} md={2}>
              Number:
              {get_searched_parcel?.phoneNumber && <b>{get_searched_parcel?.phoneNumber}</b>}
            </Grid>
            <Grid item xs={3} md={1}>
              Rider:
            </Grid>
            <Grid item xs={3} md={1}>
              {get_searched_parcel?.rider?.name && <b>{get_searched_parcel?.rider?.name}</b>}
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12} md={12} className={classes.hidePrint}>
        {loading && <LinearProgress />}
      </Grid>
      <Grid item xs={12} md={12} className={classes.onlyPrint}>
        <br />
        <h1 style={{ textAlign: 'center' }}>{process.env.REACT_APP_COURIER_COMPANY_NAME}</h1>
      </Grid>
      <Grid item xs={12} md={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="a spanning dense table" padding="checkbox">
            <TableHead style={{ backgroundColor: 'lightgray' }}>
              <TableRow>
                <TableCell className={classes.printStyle} align="left">
                  <b>No.</b>
                </TableCell>
                <TableCell className={classes.printStyle} align="center">
                  <b>APN</b>
                  <hr style={{ margin: 0 }} />
                  Invoice
                </TableCell>
                {!print && (
                  <TableCell className={clsx(classes.printStyle, classes.hidePrint)} align="left">
                    <b>Rider</b>
                  </TableCell>
                )}
                {!print && (
                  <TableCell
                    className={clsx(classes.printStyle, classes.hidePrint)}
                    style={{ width: '5rem' }}
                    align="left"
                    size="small"
                  >
                    <b>Status</b>
                  </TableCell>
                )}
                <TableCell className={classes.printStyle} align="left">
                  <b>Company</b>
                </TableCell>
                <TableCell className={classes.printStyle} align="left">
                  <b>Customer</b>
                </TableCell>
                <TableCell className={classes.printStyle} align="left">
                  <b>Address</b>
                </TableCell>
                <TableCell className={`${classes.printStyle}`} align="right">
                  <b>COD</b>
                </TableCell>
                <TableCell className={`${classes.printStyle}`} align="left">
                  <b>Receive</b>
                </TableCell>
                <TableCell className={clsx(classes.printStyle, classes.hidePrint)} align="left">
                  <b>Action</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {get_rows.map((row: any, i: number) => (
                <Rows row={row} serial={i + 1} />
              ))}
              <TableRow>
                {!print && (
                  <TableCell
                    className={clsx(classes.printStyle, classes.hidePrint)}
                    align="right"
                    colSpan={2}
                  ></TableCell>
                )}
                <TableCell className={classes.printStyle} align="right" colSpan={4}></TableCell>
                <TableCell className={classes.printStyle} align="center">
                  Total
                </TableCell>
                <TableCell
                  className={`${classes.printStyle}`}
                  align="left"
                  style={{ fontSize: '1.2rem', padding: '0 5px' }}
                >
                  <b>{get_rows.reduce((prev, curr) => prev + (curr.merchant_COD ?? 0), 0)}</b>
                </TableCell>
                <TableCell className={`${classes.printStyle} ${classes.receiveColumn}`} align="right"></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={12} md={12} className={classes.onlyPrint}>
        <br />
        <div style={{ textAlign: 'center' }}>
          <Table
            style={{
              maxWidth: '10cm',
              // marginLeft: "auto",
              // marginRight: "auto",
            }}
            size="small"
            aria-label="simple table"
          >
            <TableBody>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Date
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {moment().format('DD MMM YYYY')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Rider Name
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {get_rider?.label?.toUpperCase()}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Total Parcel:
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {get_rows.length}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Total COD:
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {get_rows.reduce((prev, curr) => prev + (curr.COD ?? 0), 0)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Bkash/Nagad &nbsp;
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {' '}
                  &nbsp;
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Total cash received &nbsp;
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {' '}
                  &nbsp;
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Due &nbsp;
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {' '}
                  &nbsp;
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </Grid>
    </Grid>
  );
}
